import React from "react"
import { graphql } from "gatsby"
import Grid from "@material-ui/core/Grid"
import styled from "styled-components"

import SEO from "../components/seo"
import Section from "../components/Section"
import { Container } from "../components/Container"
import HeroFullWidth from "../components/HeroFullWidth"
import SvgBorderTop from "../components/SvgBorderTop"
import BreadCrumbs from "../components/BreadCrumbs"
import vSpacing from "../styles/vSpacing"
import Vspacer from "../components/Vspacer"
import localeData from "../locale"
import VacancySelection from "../components/VacancySelection"
import CustomBlockRenderer from "../components/custom-block-renderer"

const Title4 = styled.h2`
  text-align: center;
  color: ${(props) => props.theme.primaryColors.primary};
`

export const destinationQuery = graphql`
  query DestinationsTemplateQuery($id: String!) {
    sanityVacancyCountry(id: { eq: $id }) {
      id
      _rawLocaleTitle
      image {
        asset {
          gatsbyImageData(width: 1600, fit: FILLMAX, placeholder: BLURRED)
        }
      }
      _rawContent(resolveReferences: { maxDepth: 8 })
    }
    sanityCompanyInfo {
      email
    }
    sanityStoriesPage {
      id
      _rawLocaleTitle
    }
    sanityAllVacanciesPage {
      id
      _rawLocaleTitle
    }
  }
`

const DestionationsPage = ({ data, pageContext }) => {
  const { locale } = pageContext
  const { _rawLocaleTitle, image, _rawContent } = data.sanityVacancyCountry
  const { email } = data.sanityCompanyInfo
  const storyPageTitle = data.sanityStoriesPage._rawLocaleTitle
  const vacancyPageTitle = data.sanityAllVacanciesPage._rawLocaleTitle

  return (
    <>
      <SEO title={_rawLocaleTitle[locale]} />
      {_rawLocaleTitle && (
        <BreadCrumbs
          color={image && "white"}
          pageTitle={_rawLocaleTitle[locale]}
          locale={locale}
        />
      )}
      {image && <HeroFullWidth img={image} title={_rawLocaleTitle[locale]} />}
      <Vspacer paddingTop={vSpacing.baseX7}></Vspacer>
      {_rawContent &&
        _rawContent.length > 0 &&
        _rawContent.map((content, index) => {
          return CustomBlockRenderer(
            content,
            index,
            locale,
            storyPageTitle,
            vacancyPageTitle,
            email
          )
        })}

      <SvgBorderTop grey>
        <Container grey paddingBottom>
          <Vspacer marginBottom={vSpacing.baseX6}>
            <Grid container justify="center">
              <Grid item md={6}>
                <Title4 center>
                  {localeData._rawDestinationVacancies[locale]}{" "}
                  {_rawLocaleTitle[locale]}
                </Title4>
              </Grid>
            </Grid>
          </Vspacer>
          <Section>
            <VacancySelection
              locale={locale}
              filter={_rawLocaleTitle[locale]}
            />
          </Section>
        </Container>
      </SvgBorderTop>
    </>
  )
}

export default DestionationsPage
